














import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
class TablePerPage extends Vue {
  @Prop() disabled: boolean;
  usersPerPageOptions: number[] = [20, 30, 40, 50];

  mounted() {
    if (this.$route.query.perpage) {
      this.usersPerPage = parseInt(this.$route.query.perpage as string, 10);
    } else {
      this.usersPerPage = 20;
    }
  }

  get usersPerPage() {
    return this.$route.query.perpage ? parseInt(this.$route.query.perpage as string, 10) : 20;
  }

  set usersPerPage(newVal) {
    if (newVal === this.usersPerPage) return;
    this.$emit('usersPerPageUpdated', newVal, this.usersPerPage);
  }
}
export default TablePerPage;
